import classNames from 'classnames';
import { FC } from 'react';

import { IcDeleteIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, popupItemStyles } from '@gem/ui-kit';

import styles from './DeleteMemberPermissions.styles.m.css';

interface IDeleteMemberPermissionsProps {
  onDeleteButtonClick(): void;
}

export const DeleteMemberPermissions: FC<IDeleteMemberPermissionsProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={classNames(styles.divider, styles.dividerFooter)} />
      <button
        className={classNames(styles.deleteButton, popupItemStyles.interactive)}
        onClick={props.onDeleteButtonClick}
        tabIndex={0}
      >
        <IconView
          Icon={IcDeleteIcon}
          className={styles.deleteIcon}
        />
        {t('call_delete_permissions')}
      </button>
    </>
  );
};
